import $ from 'jquery';

$(document).on('ready turbo:load', function () {
  const forms = $('.navbar-searchForm');

  forms.each(function (index, element) {
    const overlay = $(element).find('.js-search-overlay');
    const input = $(element).find<HTMLInputElement>('.js-search');
    const form = $(element);

    let results = overlay.find<HTMLAnchorElement>('.searchPreview-item');
    let request: JQuery.jqXHR | null = null;
    let activeIndex = -1;
    let isNavigating = false;

    const arrowDown = function (): void {
      if (activeIndex < results.length - 1) {
        activeIndex++;
      }
      updateView();
    };

    const arrowUp = function (): void {
      if (activeIndex > -1) {
        activeIndex = (activeIndex - 1) % results.length;
      }
      updateView();
    };

    const confirm = function (): void {
      document.location = results.get(activeIndex)!.href;
    };

    const cancel = function (): void {
      input.trigger('blur');
      input.removeClass('active');
      activeIndex = -1;
      isNavigating = false;
      overlay.hide();
    };

    const updateView = function (): void {
      results.removeClass('active');
      if (activeIndex === -1) {
        input.trigger('focus');
      } else {
        results.eq(activeIndex).addClass('active');
        input.trigger('blur');
      }
    };

    document.addEventListener('keydown', function (event) {
      event = event || window.event;
      if (isNavigating) {
        switch (event.keyCode) {
          case 13:
            if (activeIndex > -1) {
              confirm();
              event.preventDefault();
            }
            break;
          case 27:
            event.preventDefault();
            cancel();
            break;
          case 38:
            arrowUp();
            event.preventDefault();
            break;
          case 39:
            if (activeIndex > -1) {
              confirm();
              event.preventDefault();
            }
            break;
          case 40:
            arrowDown();
            event.preventDefault();
            break;
        }
      }
    });

    input.on('input', function (event) {
      event.preventDefault();
      const term = input.val();
      if (request) {
        request.abort();
        request = null;
      }
      if (term && term.length > 2) {
        input.addClass('search-loading');
        request = $.ajax({
          url: `${form.data('preview')}?s=${encodeURIComponent(term)}`,
        });
        request.done(function (content) {
          input.removeClass('search-loading');
          overlay.html(content);
          results = overlay.find<HTMLAnchorElement>('.searchPreview-item');
          request = null;
          input.addClass('active');
        });
      } else {
        overlay.empty();
        input.removeClass('active');
      }
    });

    input.on('focus', function () {
      isNavigating = true;
      overlay.show();
      if (results.length > 0) {
        input.addClass('active');
      }
    });

    input.on('click', function () {
      activeIndex = -1;
      updateView();
    });

    $('.wrap').on('click', () => cancel());
  });
});
